import i18n from "../../i18n";
import React from "react";
import { Table, Text, Paper, Button, Stack, Group } from "@mantine/core";
import { getEntityLabel } from "../../data/mcaEntities";

const renderValue = (value, highlight) => {
  if (!value || value === "—") {
    return (
      <Text size="sm" color="dimmed">
        —
      </Text>
    );
  }
  return (
    <Text
      size="sm"
      color={highlight ? "teal" : undefined}
      weight={highlight ? 500 : undefined}
      strikethrough={highlight === "old"}
      sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
    >
      {value}
    </Text>
  );
};

const EntityLinkCard = ({
  action,
  targetEntity,
  targetEntityCode,
  onViewEntity,
}) => {
  const entityLabel = getEntityLabel(targetEntity);
  const isDelete = action === "DELETE";

  return (
    <Paper p="md" withBorder>
      <Stack spacing="sm">
        {isDelete ? (
          <Text color="red" weight={600}>
            Proposed deletion of this record
          </Text>
        ) : (
          <Text size="sm" weight={600}>
            New {entityLabel} proposed
          </Text>
        )}
        {targetEntityCode && (
          <Text size="sm" color="dimmed">
            {targetEntityCode}
          </Text>
        )}
        {onViewEntity && (
          <Group>
            <Button color="teal" onClick={onViewEntity}>{i18n.t("View details")}</Button>
          </Group>
        )}
      </Stack>
    </Paper>
  );
};

const McaDataDiff = ({
  action,
  payloadDisplay = [],
  targetEntity,
  targetEntityCode,
  onViewEntity,
}) => {
  if (action === "CREATE" || action === "DELETE") {
    return (
      <EntityLinkCard
        action={action}
        targetEntity={targetEntity}
        targetEntityCode={targetEntityCode}
        onViewEntity={onViewEntity}
      />
    );
  }

  if (payloadDisplay.length > 0) {
    const isUpdate = action === "UPDATE";

    return (
      <Table striped withBorder verticalSpacing="sm" highlightOnHover>
        <thead>
          <tr>
            <th>{i18n.t("Field")}</th>
            {isUpdate ? (
              <>
                <th>{i18n.t("Original")}</th>
                <th>{i18n.t("Proposed")}</th>
              </>
            ) : (
              <th>{i18n.t("Value")}</th>
            )}
          </tr>
        </thead>
        <tbody>
          {payloadDisplay.map((field) => (
            <tr
              key={field.key}
              style={
                isUpdate && field.changed
                  ? { backgroundColor: "rgba(0, 150, 136, 0.05)" }
                  : undefined
              }
            >
              <td style={{ verticalAlign: "top", width: "20%" }}>
                <Text size="sm" weight={600}>
                  {field.label}
                </Text>
              </td>
              {isUpdate ? (
                <>
                  <td style={{ verticalAlign: "top", width: "40%" }}>
                    {renderValue(
                      field.originalDisplayValue,
                      field.changed ? "old" : false
                    )}
                  </td>
                  <td style={{ verticalAlign: "top", width: "40%" }}>
                    {renderValue(
                      field.displayValue,
                      field.changed ? true : false
                    )}
                  </td>
                </>
              ) : (
                <td style={{ verticalAlign: "top" }}>
                  {renderValue(field.displayValue)}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }

  if (action === "UPDATE") {
    return <Text color="dimmed">No field changes in payload.</Text>;
  }

  return null;
};

export default McaDataDiff;
